import { Action, combineReducers } from '@ngrx/store';
import { BookWidgetStore } from '../../models/states/book-widget-store.interfaces';
import * as fromAem from './aem.reducer';
import * as fromBookWidgetReducer from './book-widget.reducer';
import * as fromCatalogApi from './catalog-api.reducer';
import * as fromDefaultLookup from './default-lookup.reducer';
import * as fromFeatureFlags from './feature-flags.reducer';
import * as fromGeoLocation from './geo-location.reducer';
import * as fromLoginDashboard from './login-dashboard.reducer';
import * as fromQueryPrams from './query-params.reducer';
import * as fromRetrieveSearch from './retrieve-search.reducer';
import * as fromSavedSearch from './saved-search.reducer';
import * as fromPredictiveSearch from './predictive-search.reducer';

export function BookWidgetReducers(store: BookWidgetStore, action: Action) {
  return combineReducers({
    [fromAem.AemStateKey]: fromAem.aemReducer,
    [fromGeoLocation.GeoLocationStateKey]: fromGeoLocation.geoLocationReducer,
    [fromCatalogApi.CatalogApiStateKey]: fromCatalogApi.catalogApiReducer,
    [fromDefaultLookup.DefaultLookupStateKey]:
      fromDefaultLookup.defaultLookupReducer,
    [fromRetrieveSearch.RetrieveSearchStateKey]:
      fromRetrieveSearch.retrieveSearchReducer,
    [fromFeatureFlags.FeatureFlagsStateKey]:
      fromFeatureFlags.featureFlagsReducer,
    [fromBookWidgetReducer.BookWidgetStateKey]:
      fromBookWidgetReducer.bookWidgetReducer,
    [fromQueryPrams.QueryParamsStateKey]: fromQueryPrams.queryParamsReducer,
    [fromLoginDashboard.LoginDashboardStateKey]:
      fromLoginDashboard.loginDashboardReducer,
    [fromSavedSearch.SavedSearchStateKey]: fromSavedSearch.savedSearchReducer,
    [fromPredictiveSearch.PredictiveSearchStateKey]:
      fromPredictiveSearch.predictiveSearchReducer
  })(store, action);
}
